import React, { Component, useState, useRef } from "react";
import Cropper from 'react-cropper';
import Button from '@material-ui/core/Button';
import 'cropperjs/dist/cropper.css';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    paper: {
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        border: 'solid 1px #dfdfe6',
        boxShadow: "0 24px 40px -16px rgba(6, 31, 128, 0.2)",
        zIndex: 2,
        margin: "0 auto"
    },
    backModal: {
        position: 'fixed',
        top: 0,
        left: 0,
        backgroundColor: "rgba(0,0,0,0.8)",
        width: "100vw",
        height: "100vh",
        padding: "2rem",
        zIndex: 99
    },
    closeButton: {
        position: "absolute",
        bottom: "20px",
        right: "20px",
    },
    mainButon: {
        borderRadius: 6,
        fontFamily: "IBM Plex Sans",
        fontSize: 14,
        fontWeight: 500,
        boxShadow: 'none',
        textTransform: 'none',
        border: 'solid 1px #97c1ff',
        color: '#044ada',
        marginTop: 10,
        padding: '10px 20px',
        cursor: 'pointer',
    }
}));

export default function CropImage({visible,arquivo}) {

    const [preview, setPreview] = useState(undefined);
    const [file, setFile] = useState(undefined);

    const cropper = useRef(null)

    const onChangeHandler = event => {
        let reader = new FileReader();
        if (reader) {
            if (event.target) {
                reader.readAsDataURL(event.target.files[0])
                reader.onload = () => setFile(reader.result);
            }
        }
    }



    const _crop = () => {
        setPreview(
            [cropper.current.getCroppedCanvas({
                fillColor: '#fff',
                imageSmoothingEnabled: false,
                imageSmoothingQuality: 'high',
            }).toDataURL()].map((value, key) => {
                return (
                    <div key={key}>
                        <img src={value} style={{ width: "200px", height: "200px", borderRadius: "100px", margin: "0 auto", border: 'solid 1px #c2c4d1' }} />
                    </div>
                );
            })
        )
    }

   
        return (
            <div>
                {visible && <div style={{ display: "flex" }}>
                    <Cropper
                        ref={cropper}
                        src={file ? file : arquivo}
                        style={{ height: '90vh', width: '75vw' }}
                        aspectRatio={16 / 16}
                        guides={true}
                        crop={_crop.bind(this)}
                        autoCrop={true}
                    />
                    <div style={{ padding: "2rem", width: '25vw', minWidth: '300px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center', height: '100%' }}>
                            <p style={{ fontFamily: "IBM Plex Sans", fontSize: 24, fontWeight: 'bold', color: '#5e6784', }}>Preview</p>
                            {preview}
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <label style={{
                                    borderRadius: 6,
                                    fontFamily: "IBM Plex Sans",
                                    fontSize: 14,
                                    fontWeight: 500,
                                    boxShadow: 'none',
                                    textTransform: 'none',
                                    border: 'solid 1px #97c1ff',
                                    color: '#044ada',
                                    margin: 10,
                                    padding: '10px 20px',
                                    cursor: 'pointer',
                                }} htmlFor="input-arquivo" role="button">Outra foto</label>
                                <input style={{ display: 'none' }} id="input-arquivo" type="file" name="file" accept=".jpg,.jpeg,.png" onChange={onChangeHandler} />
                                <Button variant="contained" color="primary" size="small" style={{
                                    padding: '10px 20px',
                                    fontFamily: "IBM Plex Sans",
                                    fontSize: 14,
                                    fontWeight: 500,
                                    textTransform: 'none',
                                    margin: 10
                                }}>Enviar</Button>
                            </div>
                        </div>
                    </div></div>}
            </div>
        );
    
}